import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.a.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1b596wh-0"
})(["display:flex;flex-flow:column;cursor:pointer;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiDD;
});
export var Cover = styled.div.withConfig({
  displayName: "partials__Cover",
  componentId: "sc-1b596wh-1"
})(["display:flex;flex-direction:column;justify-content:space-between;min-height:180px;border-radius:", ";background-color:", ";background-image:", ";background-position:center;background-size:cover;", " color:rgb(0 0 0 / 0.7);text-align:center;", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, function (_ref4) {
  var backgroundImage = _ref4.backgroundImage;
  return "url(".concat(backgroundImage, ")");
}, getFont(0), minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 180px;\n  "]))));
export var Content = styled.div.withConfig({
  displayName: "partials__Content",
  componentId: "sc-1b596wh-2"
})(["display:flex;flex-direction:column;flex-grow:1;padding:0;margin-top:4px;", ";"], function (_ref5) {
  var isCompact = _ref5.isCompact;
  return !isCompact && css(["h2{margin:8px 0;}h3{margin-bottom:8px;}"]);
});
export var Title = styled.h2.withConfig({
  displayName: "partials__Title",
  componentId: "sc-1b596wh-3"
})(["display:block;font-weight:700;color:", ";", ";", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.cardsTitleColor);
}, getFont(0, 'compact'), minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(0, 'compact')));
export var Subtitle = styled.h3.withConfig({
  displayName: "partials__Subtitle",
  componentId: "sc-1b596wh-4"
})(["display:block;color:", ";", ";", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.cardsSubtitleColor);
}, getFont(0, 'compact'), minMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(0, 'compact')));
export var Action = styled.div.withConfig({
  displayName: "partials__Action",
  componentId: "sc-1b596wh-5"
})(["margin-top:auto;svg{margin-left:6px;vertical-align:middle;}span{cursor:pointer;}"]);